export const getIdStart = (id = '') => id.substring(0, 8);

export const generateUniqueString = () => {
  const timestamp = Date.now();
  const randomString = Math.random().toString(36).substring(2, 15);

  return `${timestamp}-${randomString}`;
};

export const encodeToBase64 = (str?: string | null) => {
  if (!str) {
    return '';
  }

  // TODO: add encryption
  return str;
}

export const decodeFromBase64 = (str?: string | null) => {
  if (!str) {
    return '';
  }

  // TODO: add decryption
  return str;
}


export const convertToNumericString = (value: string) => {
  return (
    value
      // Replace commas with dots
      .replace(/,/g, '.')
      // Remove any characters that are not digits or dots
      .replace(/[^\d.]/g, '')
      // Only allow one dot in the value
      .replace(/(\..*?)\..*/g, '$1')
  );
};
